import { createFileRoute } from '@tanstack/react-router'
import {
  modelPricesQueryOptions,
  plansQueryOptions,
  usageTypesQueryOptions,
} from '@/lib/queries/admin'
import { creditPacks } from '@/lib/queries/stripe'
import { AdminPlansPricing } from '@/features/admin'

export const Route = createFileRoute('/_authenticated/admin/plans')({
  loader: ({ context }) => {
    void context.queryClient.query({
      ...plansQueryOptions(),
      staleTime: 'static',
    })
    void context.queryClient.query({
      ...usageTypesQueryOptions(),
      staleTime: 'static',
    })
    void context.queryClient.query({
      ...modelPricesQueryOptions(),
      staleTime: 'static',
    })
    void context.queryClient.query({
      ...creditPacks.all(),
      staleTime: 'static',
    })
  },
  component: AdminPlansPage,
})

function AdminPlansPage() {
  return (
    <div className='w-full space-y-6'>
      <div>
        <h2 className='font-heading text-xl'>Plans & Pricing</h2>
        <p className='text-muted-foreground text-sm'>
          What each plan includes, and what a credit buys
        </p>
      </div>
      <AdminPlansPricing />
    </div>
  )
}
